export const enum ModalTypes {
    alert = 'alert',
    confirm = 'confirm',
    prompt = 'prompt',
    password = 'password',
    default = 'default',
    form = 'form',
}
